import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';

export interface MicrosoftDirectoryConfigInput {
  enabled?: boolean;
  tenantId?: string;
  clientId?: string;
  clientSecret?: string | null;
  scopes?: string[];
  hasClientSecret?: boolean;
}

export interface DirectoryConfig {
  microsoft?: MicrosoftDirectoryConfigInput;
}

export interface DirectoryConnectionTestPayload {
  provider: 'microsoft';
}

export interface DirectoryConnectionTestResult {
  success: boolean;
  message: string;
}

/**
 * Service for the directory integration settings
 * (`/api/v1/settings/directory/config`) and its connection-test endpoint.
 */
@Injectable({ providedIn: 'root' })
export class DirectorySettingsService {
  private readonly http = inject(HttpClient);
  private readonly configPath = '/api/v1/settings/directory/config';
  private readonly connectionTestsPath = '/api/v1/settings/directory/connection-tests';

  getConfig(): Observable<DirectoryConfig> {
    return this.http.get<DirectoryConfig>(this.configPath);
  }

  patchConfig(payload: DirectoryConfig): Observable<DirectoryConfig> {
    return this.http.patch<DirectoryConfig>(this.configPath, payload);
  }

  testConnection(payload: DirectoryConnectionTestPayload): Observable<DirectoryConnectionTestResult> {
    return this.http.post<DirectoryConnectionTestResult>(this.connectionTestsPath, payload);
  }
}
